import IndFlagIcon from '../../assets/images/indiaFlag.png';
import YoutubeIcon from '../../assets/icons/youtubeIcon.svg';
import InstaIcon from '../../assets/icons/instaIcon.svg';
import FaceBookIcon from '../../assets/icons/fbIcon.svg';
import LinkedInIcon from '../../assets/icons/linkedinIcon.svg';
import TwitterIcon from '../../assets/icons/twitterIcon.svg';
import Chat from './chat';

export default function Footer() {
  return (
    <div className="bg-black h-screen flex flex-col px-5 lg:gap-y-6 py-5 lg:px-10">
      <div className="hidden lg:block">
        <Chat />
      </div>
      <div className="lg:py-0 flex flex-col gap-y-10 lg:gap-y-0 lg:flex-row items-start">
        <div className="lg:w-[50%]">
          <p className="font-lato font-[500] text-white text-[30px] lg:text-[50px] font-[800]">
            buildatscale.
          </p>
          <p className="font-lato font-[500] text-white text-[18px] lg:text-[1.5em]">
            Our Presence
          </p>
          <div className="flex flex-col lg:flex-row lg:items-center mt-5 gap-y-4 lg:gap-x-10">
            <div className="flex items-center gap-x-4">
              <img
                src={IndFlagIcon}
                className="w-[40px] h-[40px] rounded-full object-cover"
              ></img>
              <div className="flex flex-col">
                <p className="text-textColor5 font-lato">India</p>
                <p className="text-textColor5 font-lato">
                  Buildatscale Private Limited
                </p>
                <p className="text-textColor5 font-lato">
                  10th Floor, Alt F Joy Towers, Sector 62,
                  <br />
                  Noida, Uttar Pradesh - 201309
                </p>
                <hr />

                <p className="text-textColor5 font-lato">
                  PLOT NO100, ALTF 58, SECTOR 58,
                  <br />
                  NOIDA, Gautambuddha Nagar Uttar Pradesh - 201309
                </p>
              </div>
              <hr />
            </div>
          </div>
        </div>
        <div className="lg:w-[60%] flex flex-col lg:flex-row gap-y-5 lg:gap-y-10 lg:gap-x-20">
          <div className="w-[2px] h-[300px] bg-white hidden lg:flex"></div>
          <div className="flex flex-col gap-y-5 relative">
            <p className="text-white font-lato text-[22px] lg:text-[1.5em] font-[500]">
              Quick Links
            </p>
            <div className="flex flex-col gap-y-1 lg:gap-y-4">
              <a href="/" className="font-lato text-textColor5 text-[1em]">
                Homepage
              </a>
              <a
                href="https://buildatscale.com/blog/insights/"
                className="font-lato text-textColor5 text-[1em]"
              >
                Insights
              </a>
              <a
                href="https://buildatscale.com/blog/contact-us/"
                className="font-lato text-textColor5 text-[1em]"
              >
                Contact us
              </a>
            </div>
          </div>
          <div className="w-[2px] h-[300px] bg-white hidden lg:flex"></div>
          <div className="flex flex-col gap-y-5 lg:gap-y-10">
            <p className="text-white font-lato text-[22px] lg:text-[1.5em] font-[500]">
              Follow us
            </p>
            <div className="">
              <div className="flex gap-x-4">
                <a
                  href=" https://www.facebook.com/buildatscale/"
                  target="_blank"
                >
                  {' '}
                  <img src={FaceBookIcon}></img>
                </a>
                <a
                  href="https://www.instagram.com/buildatscale"
                  target="_blank"
                >
                  <img src={InstaIcon}></img>
                </a>
                <a
                  href="https://www.youtube.com/@buildatscaletoday"
                  target="_blank"
                >
                  <img src={YoutubeIcon}></img>
                </a>
              </div>
            </div>
            <div className="h-[2px] w-full bg-white"></div>
            <div className="flex flex-col gap-y-4">
              <p className="font-lato text-textColor5 font-[400] text-[1em]">
                Ph: +91 99 118 00399
              </p>

              <p className="font-lato text-textColor5 font-[400] text-[1em]">
                support: support@buildatscale.com
              </p>
              <p className="font-lato text-textColor5 font-[400] text-[1em]">
                payments: accounts@buildatscale.com
              </p>
              <p className="font-lato text-textColor5 font-[400] text-[1em]">
                sales/ideas: sarthak@buildatscale.com
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="text-white lg:text-center text-[1em] py-4 lg:py-0 font-[400]">
        © buildatscale 2026
      </div>
    </div>
  );
}
